/**
 * Check if element visually fits within its render container
 */
const isFullyVisible = (args) => {
    const { flyoutBounds, visualContainerBounds, renderContainerBounds } = args;
    if (renderContainerBounds.left + flyoutBounds.left < visualContainerBounds.left) {
        return false;
    }
    if (renderContainerBounds.top + flyoutBounds.top < visualContainerBounds.top) {
        return false;
    }
    if (renderContainerBounds.left + flyoutBounds.left + flyoutBounds.width >
        visualContainerBounds.right) {
        return false;
    }
    if (renderContainerBounds.top + flyoutBounds.top + flyoutBounds.height >
        visualContainerBounds.bottom) {
        return false;
    }
    return true;
};
export default isFullyVisible;
